<template>
  <article class="advanced-search">
    <template v-for="(item, index) in searchCriterias" v-if="dataFields.length > 0 && groups.length > 0">
      <div class="advanced-search__row">
        <div class="advanced-search__control">
          <SelectList label="Label_SearchFiled" v-model="item.field" :options="dataFieldsOptions" />
        </div>

        <div class="advanced-search__control">
          <SelectList label="Label_SearchOperation" v-model="item.op" :options="searchOperationsOptions" acc="control" v-if="shouldShowControls(item.field)" />
          <SelectList label="Label_SearchOperation" v-model="item.op" :options="dateOperationsOptions" acc="control" v-else-if="shouldShowDateControls(item.field)" />
        </div>

        <div class="advanced-search__control">
          <SelectList label="Label_SearchTerm" v-model="item.value" :options="groupOptions" v-if="item.field == '__group'" acc="term" />
          <SelectList label="Label_SearchTerm" v-model="item.value" :options="memberActivityOptions" v-else-if="item.field == '__memberActivity'" acc="term" />
          <SelectList label="Label_SearchTerm" v-model="item.value" :options="memberActivityOptions" v-else-if="item.field == '__activeMember'" acc="term" />
          <SelectList label="Label_SearchTerm" v-model="item.value" :options="memberActivityOptions" v-else-if="item.field == '__inactiveMember'" acc="term" />
          <TextBox label="Label_SearchTerm" v-model="item.value" v-else-if="shouldShowSearchBar(item.op)" acc="term" />
          <TextBox label="Label_SearchTerm" type="datetime" v-model="item.value" v-else-if="shouldShowDateTimePicker(item.op)" acc="term" />
        </div>

        <div class="advanced-search__control">
          <label class="form__label"></label>
          <a href="javascript: void(0)" @click="remove(index)">
            <i class="icon icon--delete"></i>
          </a>
        </div>
      </div>
    </template>

    <div class="advanced-search__actions">
      <Btn label="Label_SaveButton" @click="triggerSave" v-if="searchCriterias && searchCriterias.length > 0" acc="saveSearchButton" />
      <Btn label="Label_AdvancedSearch_AddCondition" @click="addCondition" acc="addCondition" />
      <Btn :label="searchButtonLabel" @click="triggerSearch" v-if="searchCriterias && searchCriterias.length > 0" />
    </div>

    <div class="advanced-search__actions" v-if="searchCriterias.length <= 0">
      <SelectList label="Label_Search" v-model="currentSavedSearch" :options="savedSearchCriteriasOptions" v-if="savedSearchCriterias.length > 0" acc="current" @change="loadSavedSearchCriterias" />
    </div>

    <sweet-modal :title="L.localize('SearchCriterias_Title')" ref="saveSearchCriterias">
      <TextBox label="SearchCriterias_Title" v-model="modalSaveSearchCriterias.name" :validate="$v.modalSaveSearchCriterias" modelPath="name" acc="searchCriteriasName" @input="$v.modalSaveSearchCriterias.name.$touch" />

      <Btn v-on:click="save" label="Send" acc="saveSearchCriterias" />
    </sweet-modal>
  </article>
</template>

<script>
import Dropdown from 'components/partials/Dropdown'
import { SweetModal } from 'sweet-modal-vue'
import { TextBox, SelectList, Btn } from 'components/layout/forms'
import L from 'services/Localization'
import { mapGetters } from 'vuex'
import groupModel from 'models/group'
import { required } from 'vuelidate/lib/validators'
import { Validation } from 'components/helpers'
import notifications from 'mixins/notifications'

export default {
  name: 'advanced-search',
  components: { TextBox, SelectList, Btn, SweetModal, Validation, Dropdown },
  mixins: [notifications],
  props: {
    searchCriterias: {
      type: Array,
      required: false,
      default: () => ([])
    },
    searchButtonLabel: {
      type: String,
      required: false,
      default: 'Label_AdvancedSearch'
    }
  },
  data() {
    return {
      L: L,
      triggered: false,
      currentSavedSearch: '',
      modalSaveSearchCriterias: {
        name: ''
      }
    }
  },
  validations: {
    modalSaveSearchCriterias: {
      name: { required }
    }
  },
  computed: {
    ...mapGetters({
      groups: 'allGroups',
      searchOperations: 'searchOperations',
      dataFields: 'dataFields',
      savedSearchCriterias: 'savedSearchCriterias'
    }),
    baseFields: () => [
      { value: '__group', label: L.localize('Settings_Group_Breadcrumb') },
      { value: '__memberActivity', label: L.localize('MemberData_State') },
      { value: '__subscriptionStartDate', label: L.localize('MemberData_SubscriptionStartDate') },
      { value: '__subscriptionEndDate', label: L.localize('MemberData_SubscriptionEndDate') },
      { value: '__activeMember', label: L.localize('MemberData_ActiveMember') },
      { value: '__inactiveMember', label: L.localize('MemberData_InactiveMember') }
    ],
    dataFieldsOptions() {
      let sortedData = _.orderBy(this.extractProperties(), [property => property.label.toLowerCase()], ['asc']);
      return [{ value: '__disabled', label: `────────── ${L.localize('Label_MemberData')}`, isDisabled: true }]
        .concat(this.baseFields)
        .concat(this.extractFields())
        .concat([{ value: '__disabled', label: `────────── ${L.localize('Label_CustomFields')}`, isDisabled: true }])
        .concat(sortedData)
    },
    searchOperationsOptions() {
      return this.searchOperations.map((operation) => {
        return {
          value: operation,
          label: L.localize(operation)
        }
      })
    },
    dateOperationsOptions() {
      return ["IsAfter", "IsBefore", "Is"].map((operation) => {
        return {
          value: operation,
          label: L.localize(operation)
        }
      })
    },
    groupOptions() {
      return this.groups.map(group => {
        return { value: group.id, label: group.name }
      })
    },
    memberActivityOptions() {
      return [
        { value: true, label: L.localize('MemberData_IsActive') }
      ]
    },
    savedSearchCriteriasOptions() {
      let defaultOption = [{ value: '', label: L.localize('SearchCriterias_DefaultChoice') }]
      return defaultOption.concat(this.savedSearchCriterias.map(savedSearch => {
        return { value: savedSearch.id, label: savedSearch.name }
      }))
    },
    actions() {
      let menu = {
        label: L.localize('Label_Actions'),
        links: []
      }
      menu.links.push({
        label: L.localize('Settings_Group_Delete'),
        bypassRouter: true,
        asFunction: true,
        url: 'delete',
        acc: 'delete'
      })
      return menu
    }
  },
  beforeCreate() {
    this.$store.dispatch('getAllGroups')
    this.$store.dispatch('getSearchOperations')
    this.$store.dispatch('getInternalDataFields')
    this.$store.dispatch('getSavedSearchCriterias')
  },
  methods: {
    shouldShowSearchBar(operation) {
      return !(operation === 'IsSet' || operation === 'IsNotSet' || operation === 'IsAfter' || operation === 'Is' || operation === 'IsBefore')
    },
    shouldShowControls(field) {
      return _.find(this.baseFields, { value: field }) === undefined
    },
    shouldShowDateControls(field) {
      return (field === '__subscriptionStartDate' || field === '__subscriptionEndDate')
    },
    shouldShowDateTimePicker(operation) {
      return (operation === 'IsAfter' || operation === 'Is' || operation === 'IsBefore')
    },
    extractProperties() {
      return groupModel.extractProperties(this.groups, this.buildOption)
    },
    extractFields() {
      return this.dataFields.map((field) => {
        return {
          value: field.key,
          label: field.value
        }
      })
    },
    buildOption(property) {
      return { value: property.title, label: property.label }
    },
    generateInputName: function(prefix, index, propertyName) {
      return window.abp.utils.formatString('{0}[{1}].{2}', prefix, index, propertyName)
    },
    triggerAdvancedSearch: function() {
      this.triggered = true
      this.addCondition()
    },
    addCondition: function() {
      this.searchCriterias.push({
        field: '__group',
        op: this.searchOperations[0],
        value: ''
      })
    },
    remove: function(index) {
      this.searchCriterias.splice(index, 1)
      this.triggerSearch()
    },
    triggerSearch: _.debounce(function(event) {
      this.$emit('search', this.searchCriterias)
    }, 300),
    triggerSave: function() {
      this.$refs.saveSearchCriterias.open()
    },
    save: function() {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return;
      }

      let searchCriteria = {
        name: this.modalSaveSearchCriterias.name,
        searchCriterias: JSON.stringify(this.searchCriterias)
      }
      this.$store.dispatch('createSavedSearchCriterias', searchCriteria).then(
        () => {
          this.showNotification({
            title: L.localize('Label_SuccessCreation'),
            message: L.localize('Label_Success')
          })
          this.$store.dispatch('getSavedSearchCriterias')
          this.$refs.saveSearchCriterias.close()
        },
        () => {
          window.alert('ERROR')
          this.$refs.saveSearchCriterias.close()
        }
      )
      this.$refs.saveSearchCriterias.close()
    },
    loadSavedSearchCriterias: function() {
      let that = this
      let savedSearch = _.find(this.savedSearchCriterias, { id: this.currentSavedSearch })
      let criterias = JSON.parse(savedSearch.searchCriterias)
      criterias.forEach(function(criteria) {
        that.searchCriterias.push(criteria)
      })
      this.triggerSearch()
      this.currentSavedSearch = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// AdvancedSearch.vue?33078007